import { CategoryFieldType, CategoryFieldTypeEnum } from 'types';

export const __ConvertCFVForAPI = (
    category_fields_values: { [key: number]: string | number },
    postSlug: string,
    categoryFields?: CategoryFieldType<'detail'>[],
) => {
    return {
        post: postSlug,
        field_values: category_fields_values
            ? Object.entries(category_fields_values)
                  .filter((item) => item[1] !== undefined && item[1] !== null)
                  .map((item) => {
                      const obj: { value?: string; value_number?: number; option?: number; category_field: number } = {
                          category_field: Number(item[0]),
                      };
                      const type = categoryFields?.find((i) => i.id === Number(item[0]))?.type;
                      if (type === CategoryFieldTypeEnum.text) obj.value = item[1].toString();
                      else if (type === CategoryFieldTypeEnum.number) obj.value_number = Number(item[1]);
                      else if (type === CategoryFieldTypeEnum.boolean)
                          obj.value = item[1].toString() === '1' ? '1' : '0';
                      else if (type === CategoryFieldTypeEnum.fieldOptions) obj.option = Number(item[1]);
                      return obj;
                  })
            : [],
    };
};
